import { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

/**
 * @author Galianov Artem <a.galianov@rambler-co.ru>
 *
 * Здесь не следует использовать хок withoutSSR, т.к это компонент
 * общего назначения и вложеные withoutSSR могут приводить к ошибкам.
 * Подробнее в readme компонента withoutSSR.
 */
export default class Portal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');

    const { className, dataQa } = this.props;
    if (className) {
      this.el.className = className;
    }

    if (dataQa) {
      this.el.dataset.qa = dataQa;
    }
  }

  componentDidMount() {
    document.body.appendChild(this.el);
  }

  componentWillUnmount() {
    document.body.removeChild(this.el);
  }


  render() {
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}

Portal.propTypes = {
  /** @ignore */
  className: PropTypes.string,
  /** @ignore */
  dataQa: PropTypes.string,
};
